export default "__VITE_ASSET__38c896a8__"